import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import ErrorBoundary from '@/components/error-boundry';
import ScrollToTop from '@/components/scroll-to-top';
import Home from '@/pages/home';
import Footer from '@/sections/footer';
import Loader from '@/sections/loader';
import NavBar from '@/sections/navbar';
import ROUTES from '@/services/routes';
import React, { lazy, type ReactNode } from 'react';

const LAZY_COMPONENTS = {
  Supervision: lazy(() => import('./pages/supervision')),
  Therapy: lazy(() => import('./pages/therapy')),
  NotFound: lazy(() => import('./pages/404')),
  Contact: lazy(() => import('./pages/contact'))
};

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => (
  <div className="flex flex-col min-h-[100dvh] justify-between">
    <header>
      <NavBar />
    </header>
    <main className="grow snap-y snap-mandatory h-[100dvh] overflow-y-scroll">
      {children}

      <Footer />
    </main>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Layout>
          <ErrorBoundary>
            <React.Suspense fallback={<Loader />}>
              <Routes>
                <Route path={ROUTES.HOME} element={<Home />} />
                {/*<Route path={ROUTES.ABOUT} element={<LAZY_COMPONENTS.AboutMe />} />*/}
                <Route path={ROUTES.SUPERVISION} element={<LAZY_COMPONENTS.Supervision />} />
                <Route path={ROUTES.THERAPY_FULL} element={<LAZY_COMPONENTS.Therapy />} />
                <Route path={ROUTES.CONTACT_FULL} element={<LAZY_COMPONENTS.Contact />} />
                <Route path="*" element={<LAZY_COMPONENTS.NotFound />} />
              </Routes>
            </React.Suspense>
          </ErrorBoundary>
        </Layout>
      </Router>
    </HelmetProvider>
  );
}

export default App;
